const Spinner = ({loading}) => {
  if (!loading) {
    return <></>
  }

  return (
    <div className="spinner-border" role="status" style={{
      margin: "0 0.5rem",
      verticalAlign: "middle",
      color: "#FFFFFF",
      width: "1rem",
      height: "1rem"
    }}>
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}

export default Spinner
